import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { StatusDotIcon } from '@/components/Icons/StatusDotIcon';
import { headerSelector, themeSelector, reverseHeaderButtons, } from '@/state/config';
import { assignedAgentIdSelector, chatEventsSelector, isMobileSelector, isTalkingToBrainSelector, overviewSelector, } from '@/state/session';
import { connectionState } from '@/state/socket';
import { AvatarGroup } from '../AvatarGroup/AvatarGroup';
import { ActionContainer } from './ActionContainer/ActionContainer';
import styles from './Header.module.scss';
export const Header = memo(() => {
    const connectionStatus = useRecoilValue(connectionState);
    const headerInfo = useRecoilValue(headerSelector);
    const theme = useRecoilValue(themeSelector);
    const isMobile = useRecoilValue(isMobileSelector);
    const shouldReverseButtons = useRecoilValue(reverseHeaderButtons);
    const assignedAgentId = useRecoilValue(assignedAgentIdSelector);
    const chatEvents = useRecoilValue(chatEventsSelector);
    const isTalkingToBrain = useRecoilValue(isTalkingToBrainSelector);
    const { t } = useTranslation();
    const shouldShowConnectionStatus = chatEvents.length === 0 || isTalkingToBrain;
    const { agents } = useRecoilValue(overviewSelector);
    return (_jsxs("div", { className: cn("header-container" /* TestClassName.HeaderContainer */, styles.container, styles[theme], {
            [styles.isMobile]: isMobile,
            [styles.hasAvatars]: agents.length > 0,
            [styles.reverseButtons]: shouldReverseButtons,
        }), children: [_jsx(AvatarGroup, { avatars: agents, isAssignedToAgent: !!assignedAgentId }), _jsx("p", { className: styles.title, "data-testid": "header-title", children: _jsxs("span", { className: styles.titleContainer, children: [_jsxs("span", { children: [t(headerInfo.title), shouldShowConnectionStatus && (_jsx(StatusDotIcon, { status: connectionStatus }))] }), _jsx("span", { className: styles.agentStatus, children: headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.status })] }) }), _jsx(ActionContainer, {})] }));
});
Header.displayName = 'Header';
